import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import HomeCard from '../../components/HomeCard';
import { colors, typography } from '../../styles';

const styles = css`
  margin-top: 84px;
  @media (min-width: 768px) {
    margin-top: 98px;
  }
  @media (min-width: 992px) {
    margin-top: 160px;
  }
  .Listings_header {
    font-family: ${typography.Serif};
    font-size: 36px;
    font-weight: normal;
    line-height: 1.1;
    text-align: center;
    color: ${colors.color4};
    margin-bottom: 36px;
    padding-bottom: 27px;
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 75px;
      height: 3px;
      background-color: ${colors.color2};
    }
    @media (min-width: 768px) {
      font-size: 43px;
      padding-bottom: 28px;
      margin-bottom: 34px;
      &::after {
        width: 110px;
        height: 4px;
      }
    }
    @media (min-width: 992px) {
      font-size: 46px;
      margin-bottom: 38px;
      &::after {
        width: 120px;
        height: 5px;
      }
    }
    @media (min-width: 1200px) {
      font-size: 48px;
    }
  }
  .Listings_list {
    @media (min-width: 662px) {
      margin-left: -5px;
      margin-right: -5px;
    }
    @media (min-width: 768px) {
      margin-left: -15px;
      margin-right: -15px;
    }
  }
  .Listings_cardsWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: -30px;
  }
`;

const cardStyles = css`
  margin-bottom: 30px;
  width: 100%;
  @media (min-width: 488px) {
    max-width: 420px;
  }
  @media (min-width: 662px) {
    margin-left: 5px;
    margin-right: 5px;
    width: calc(50% - 10px);
  }
  @media (min-width: 768px) {
    margin-left: 15px;
    margin-right: 15px;
    width: calc(50% - 30px);
  }
  @media (min-width: 992px) {
    width: calc(33.333333% - 30px);
  }
  @media (min-width: 1440px) {
    width: calc(25% - 30px);
  }
`;


function Listings({ agentName, listings }) {
  return (
    <div className={styles} id="listings">
      <h3 className="Listings_header">{`${agentName}’s Listings`}</h3>
      <div className="Listings_list">
        <div className="Listings_cardsWrapper">
          {
            listings.map(listing => (
              <HomeCard className={cardStyles} home={listing} key={listing._id} />
            ))
          }
        </div>
      </div>
    </div>
  );
}

Listings.propTypes = {
  agentName: PropTypes.string.isRequired,
  listings: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Listings;



// WEBPACK FOOTER //
// ./src/pages/AgentDetail/Listings.js